var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_7881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3946 36.9248C14.8709 37.9412 16.8302 39.5807 18.031 41.439C18.2825 41.8281 17.9033 42.7518 17.4509 42.8521C15.2908 43.3306 12.7447 43.1207 10.2685 42.1042C7.79219 41.0876 5.83288 39.4482 4.63209 37.59C4.38062 37.2008 4.75984 36.277 5.21219 36.1768C7.37219 35.6983 9.91837 35.9083 12.3946 36.9248Z",
    fill: "url(#paint0_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3946 36.9248C14.8709 37.9412 16.8302 39.5807 18.031 41.439C18.2825 41.8281 17.9033 42.7518 17.4509 42.8521C15.2908 43.3306 12.7447 43.1207 10.2685 42.1042C7.79219 41.0876 5.83288 39.4482 4.63209 37.59C4.38062 37.2008 4.75984 36.277 5.21219 36.1768C7.37219 35.6983 9.91837 35.9083 12.3946 36.9248Z",
    fill: "url(#paint1_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6541 33.4133C16.0792 35.3354 17.7306 37.7839 18.4695 40.2325C18.6242 40.7454 17.9072 41.65 17.3726 41.6165C14.82 41.4564 12.059 40.4078 9.63391 38.4858C7.20881 36.5637 5.55744 34.1152 4.81852 31.6666C4.66381 31.1537 5.38077 30.2491 5.91538 30.2826C8.46803 30.4428 11.229 31.4913 13.6541 33.4133Z",
    fill: "url(#paint2_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6541 33.4133C16.0792 35.3354 17.7306 37.7839 18.4695 40.2325C18.6242 40.7454 17.9072 41.65 17.3726 41.6165C14.82 41.4564 12.059 40.4078 9.63391 38.4858C7.20881 36.5637 5.55744 34.1152 4.81852 31.6666C4.66381 31.1537 5.38077 30.2491 5.91538 30.2826C8.46803 30.4428 11.229 31.4913 13.6541 33.4133Z",
    fill: "url(#paint3_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1021 28.0022C18.227 31.2639 19.2186 34.8445 19.1217 38.0605C19.1014 38.7341 17.8847 39.5267 17.2605 39.2732C14.2795 38.0623 11.4049 35.7085 9.27998 32.4468C7.15507 29.1852 6.1635 25.6046 6.26037 22.3885C6.28066 21.715 7.49743 20.9223 8.12164 21.1758C11.1026 22.3867 13.9772 24.7405 16.1021 28.0022Z",
    fill: "url(#paint4_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6228 26.1688C7.07927 28.2754 7.96104 30.4223 9.27986 32.4466C11.4048 35.7083 14.2793 38.0621 17.2604 39.273C17.8847 39.5266 19.1013 38.7339 19.1216 38.0604C19.2186 34.8443 18.227 31.2637 16.102 28.002C14.8507 26.0814 13.3395 24.4759 11.6997 23.2329L6.6228 26.1688Z",
    fill: "url(#paint5_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6055 36.9248C36.1292 37.9412 34.1699 39.5807 32.9691 41.439C32.7177 41.8281 33.0969 42.7518 33.5492 42.8521C35.7093 43.3306 38.2554 43.1207 40.7317 42.1042C43.208 41.0876 45.1673 39.4482 46.3681 37.59C46.6195 37.2008 46.2403 36.277 45.788 36.1768C43.628 35.6983 41.0818 35.9083 38.6055 36.9248Z",
    fill: "url(#paint6_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6055 36.9248C36.1292 37.9412 34.1699 39.5807 32.9691 41.439C32.7177 41.8281 33.0969 42.7518 33.5492 42.8521C35.7093 43.3306 38.2554 43.1207 40.7317 42.1042C43.208 41.0876 45.1673 39.4482 46.3681 37.59C46.6195 37.2008 46.2403 36.277 45.788 36.1768C43.628 35.6983 41.0818 35.9083 38.6055 36.9248Z",
    fill: "url(#paint7_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3461 33.4133C34.921 35.3354 33.2696 37.7839 32.5307 40.2325C32.376 40.7454 33.0929 41.65 33.6275 41.6165C36.1802 41.4564 38.9412 40.4078 41.3663 38.4858C43.7914 36.5637 45.4427 34.1152 46.1817 31.6666C46.3364 31.1537 45.6194 30.2491 45.0848 30.2826C42.5321 30.4428 39.7712 31.4913 37.3461 33.4133Z",
    fill: "url(#paint8_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3461 33.4133C34.921 35.3354 33.2696 37.7839 32.5307 40.2325C32.376 40.7454 33.0929 41.65 33.6275 41.6165C36.1802 41.4564 38.9412 40.4078 41.3663 38.4858C43.7914 36.5637 45.4427 34.1152 46.1817 31.6666C46.3364 31.1537 45.6194 30.2491 45.0848 30.2826C42.5321 30.4428 39.7712 31.4913 37.3461 33.4133Z",
    fill: "url(#paint9_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.898 28.0022C32.7731 31.2639 31.7815 34.8445 31.8784 38.0605C31.8987 38.7341 33.1155 39.5267 33.7397 39.2732C36.7207 38.0623 39.5953 35.7085 41.7202 32.4468C43.8451 29.1852 44.8366 25.6046 44.7398 22.3885C44.7195 21.715 43.5027 20.9223 42.8785 21.1758C39.8975 22.3867 37.0229 24.7405 34.898 28.0022Z",
    fill: "url(#paint10_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3774 26.1688C43.9209 28.2754 43.0391 30.4223 41.7203 32.4466C39.5954 35.7083 36.7209 38.0621 33.7398 39.273C33.1155 39.5266 31.8988 38.7339 31.8785 38.0604C31.7816 34.8443 32.7732 31.2637 34.8982 28.002C36.1494 26.0814 37.6607 24.4759 39.3005 23.2329L44.3774 26.1688Z",
    fill: "url(#paint11_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 49.9999C34.1106 49.9999 41.0909 43.0197 41.0909 34.4091C41.0909 25.7986 34.1106 18.8184 25.5001 18.8184C16.8895 18.8184 9.9093 25.7986 9.9093 34.4091C9.9093 43.0197 16.8895 49.9999 25.5001 49.9999Z",
    fill: "url(#paint12_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 46.8363C32.3633 46.8363 37.927 41.2726 37.927 34.4094C37.927 27.5462 32.3633 21.9824 25.5001 21.9824C18.6369 21.9824 13.0731 27.5462 13.0731 34.4094C13.0731 41.2726 18.6369 46.8363 25.5001 46.8363Z",
    fill: "url(#paint13_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 45.078C31.3922 45.078 36.1687 40.3015 36.1687 34.4094C36.1687 28.5172 31.3922 23.7407 25.5 23.7407C19.6079 23.7407 14.8314 28.5172 14.8314 34.4094C14.8314 40.3015 19.6079 45.078 25.5 45.078Z",
    fill: "url(#paint14_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9093 34.409C9.9093 43.0196 16.8895 49.9998 25.5001 49.9998C34.1107 49.9998 41.0909 43.0196 41.0909 34.409C41.0909 34.3485 41.0893 34.2884 41.0886 34.228H9.91156C9.91087 34.2884 9.9093 34.3485 9.9093 34.409Z",
    fill: "url(#paint15_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8727 49.3776C34.7854 47.9448 38.6946 44.16 40.2998 39.3235L32.7064 31.73L30.9945 31.814L26.3743 27.1938L20.7434 40.2483L29.8727 49.3776Z",
    fill: "url(#paint16_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.893 31.0212L28.8355 30.2825C28.5511 30.2138 28.3025 30.0413 28.1385 29.799L26.376 27.1936C26.1627 26.8785 25.8362 26.7094 25.5001 26.6821C25.164 26.7094 24.8373 26.8785 24.6242 27.1936L22.8616 29.799C22.6977 30.0413 22.4492 30.2138 22.1647 30.2825L19.1071 31.0212C18.2777 31.2216 17.9321 32.2115 18.4565 32.8847L20.3897 35.3661C20.5695 35.5969 20.6567 35.8865 20.6342 36.1783L20.3919 39.3145C20.3263 40.1652 21.1609 40.7999 21.9631 40.5091L24.9205 39.4373C25.1073 39.3696 25.3066 39.3521 25.5001 39.3821C25.6936 39.3522 25.8928 39.3697 26.0797 39.4373L29.037 40.5091C29.8392 40.7998 30.6739 40.1652 30.6082 39.3145L30.366 36.1783C30.3434 35.8865 30.4307 35.5969 30.6105 35.3661L32.5437 32.8847C33.068 32.2115 32.7224 31.2216 31.893 31.0212Z",
    fill: "url(#paint17_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0797 39.4373L29.0371 40.5091C29.8392 40.7998 30.6739 40.1652 30.6083 39.3145L30.366 36.1783C30.3435 35.8865 30.4307 35.5969 30.6105 35.366L32.5438 32.8847C33.0682 32.2116 32.7225 31.2216 31.8931 31.0212L28.8355 30.2825C28.5511 30.2138 28.3026 30.0413 28.1386 29.799L26.376 27.1936C26.1628 26.8785 25.8362 26.7094 25.5001 26.6821V39.3821C25.6937 39.3521 25.893 39.3696 26.0797 39.4373Z",
    fill: "url(#paint18_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8931 31.0214L28.8355 30.2827C28.7311 30.2575 28.6317 30.218 28.5394 30.1665L20.7451 40.2482C21.0509 40.5437 21.5122 40.6728 21.9632 40.5093L24.9205 39.4376C25.1074 39.3698 25.3067 39.3524 25.5001 39.3824C25.6936 39.3525 25.8929 39.3699 26.0797 39.4376L29.0371 40.5093C29.8392 40.8 30.6739 40.1654 30.6083 39.3147L30.366 36.1786C30.3435 35.8868 30.4307 35.5972 30.6105 35.3663L32.5437 32.8849C33.0681 32.2117 32.7225 31.2218 31.8931 31.0214Z",
    fill: "url(#paint19_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1071 31.0214L22.1647 30.2827C22.2691 30.2575 22.3685 30.218 22.4608 30.1665L30.2551 40.2482C29.9493 40.5437 29.488 40.6728 29.037 40.5093L26.0797 39.4376C25.8928 39.3698 25.6935 39.3524 25.5001 39.3824C25.3065 39.3525 25.1073 39.3699 24.9205 39.4376L21.9631 40.5093C21.161 40.8 20.3263 40.1654 20.3919 39.3147L20.6342 36.1786C20.6567 35.8868 20.5695 35.5972 20.3897 35.3663L18.4565 32.8849C17.9321 32.2117 18.2777 31.2218 19.1071 31.0214Z",
    fill: "url(#paint20_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2933 31.73C18.1479 32.0966 18.1828 32.5336 18.4564 32.8849L20.3897 35.3663C20.5695 35.5971 20.6567 35.8867 20.6342 36.1785L20.3919 39.3147C20.3262 40.1654 21.1608 40.8001 21.9631 40.5093L24.9205 39.4375C25.1073 39.3698 25.3066 39.3523 25.5001 39.3823C25.6936 39.3524 25.8928 39.3699 26.0797 39.4375L29.037 40.5093C29.8392 40.8 30.6739 40.1654 30.6082 39.3147L30.3659 36.1785C30.3534 36.0166 30.3759 35.8558 30.428 35.7049L18.2933 31.73Z",
    fill: "url(#paint21_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7081 31.73C32.8535 32.0966 32.8187 32.5336 32.5449 32.8849L30.6117 35.3663C30.4319 35.5971 30.3446 35.8867 30.3672 36.1785L30.6094 39.3147C30.6751 40.1654 29.8404 40.8001 29.0383 40.5093L26.0809 39.4375C25.8941 39.3698 25.6947 39.3523 25.5013 39.3823C25.3078 39.3524 25.1086 39.3699 24.9217 39.4375L21.9643 40.5093C21.1622 40.8 20.3275 40.1654 20.3932 39.3147L20.6354 36.1785C20.648 36.0166 20.6255 35.8558 20.5734 35.7049L32.7081 31.73Z",
    fill: "url(#paint22_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18.8184C25.4353 18.8184 25.3711 18.82 25.3066 18.8208L22.9005 21.2269L40.4653 38.7917C40.8718 37.4013 41.0908 35.9308 41.0908 34.409C41.0908 25.7986 34.1106 18.8184 25.5 18.8184Z",
    fill: "url(#paint23_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0884 0.32666V8.56195L25.5001 17.9737L34.9119 8.56195V0.32666H16.0884Z",
    fill: "url(#paint24_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0884 0.32666V2.8896L25.4687 12.2699C25.486 12.2872 25.5143 12.2872 25.5316 12.2699L34.9119 2.8896V0.32666H16.0884Z",
    fill: "url(#paint25_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0884 0.32666V2.8896L25.4687 12.2699C25.486 12.2872 25.5143 12.2872 25.5316 12.2699L34.9119 2.8896V0.32666H16.0884Z",
    fill: "url(#paint26_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 13.7528C25.1121 13.7528 24.7242 13.6051 24.4289 13.3097L16.0884 4.96924V8.56198L25.5001 17.9737L34.9119 8.56198V4.96924L26.5714 13.3097C26.2761 13.605 25.8882 13.7528 25.5001 13.7528Z",
    fill: "url(#paint27_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 13.7528C25.1121 13.7528 24.7242 13.6051 24.4289 13.3097L16.0884 4.96924V8.56198L25.5001 17.9737L34.9119 8.56198V4.96924L26.5714 13.3097C26.2761 13.605 25.8882 13.7528 25.5001 13.7528Z",
    fill: "url(#paint28_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 13.7528C25.8882 13.7528 26.2761 13.6051 26.5714 13.3097L34.9119 4.96924V8.56198L25.5001 17.9737L16.0884 8.56198V4.96924L24.4289 13.3097C24.7242 13.605 25.1122 13.7528 25.5001 13.7528Z",
    fill: "url(#paint29_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.468 15.8361L16.4588 7.82691C15.8582 7.22632 14.8844 7.22632 14.2838 7.82691C13.6832 8.42749 13.6832 9.40132 14.2838 10.0019L25.5001 21.2184L36.7165 10.002C37.3171 9.40142 37.3171 8.42759 36.7165 7.827C36.1159 7.22642 35.1421 7.22642 34.5415 7.827L26.5322 15.8362C25.9622 16.4062 25.038 16.4062 24.468 15.8361Z",
    fill: "url(#paint30_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2838 7.84514L24.3192 17.8805C24.9714 18.5328 26.029 18.5328 26.6812 17.8805L36.7165 7.84514C36.7195 7.8422 36.7218 7.83897 36.7248 7.83602C36.7219 7.83308 36.7195 7.82985 36.7165 7.82691C36.1159 7.22632 35.1421 7.22632 34.5415 7.82691L26.5323 15.8361C25.9623 16.4061 25.0381 16.4061 24.4681 15.8361L16.4589 7.82691C15.8583 7.22632 14.8845 7.22632 14.2839 7.82691C14.2809 7.82985 14.2786 7.83308 14.2756 7.83602C14.2785 7.83897 14.2808 7.8422 14.2838 7.84514Z",
    fill: "url(#paint31_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 21.2183L33.4176 13.3008H29.0675L26.5321 15.8362C25.9621 16.4062 25.0379 16.4062 24.4679 15.8362L21.9325 13.3008H17.5824L25.5 21.2183Z",
    fill: "url(#paint32_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5197 20.2381L25.5 21.2185L35.5418 11.1768H31.1917L26.5322 15.8363C25.9788 16.3897 25.0926 16.4041 24.5197 15.883V20.2381Z",
    fill: "url(#paint33_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 22.3037C27.5305 22.3037 29.1764 20.6578 29.1764 18.6274C29.1764 16.5971 27.5305 14.9512 25.5001 14.9512C23.4698 14.9512 21.8239 16.5971 21.8239 18.6274C21.8239 20.6578 23.4698 22.3037 25.5001 22.3037Z",
    fill: "url(#paint34_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 20.7353C26.6641 20.7353 27.6077 19.7917 27.6077 18.6277C27.6077 17.4636 26.6641 16.52 25.5001 16.52C24.3361 16.52 23.3925 17.4636 23.3925 18.6277C23.3925 19.7917 24.3361 20.7353 25.5001 20.7353Z",
    fill: "url(#paint35_linear_4466_7881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3336 3.6601H14.6666C14.044 3.6601 13.5393 3.15539 13.5393 2.53284V1.12725C13.5393 0.504706 14.044 0 14.6666 0H36.3337C36.9562 0 37.4609 0.504706 37.4609 1.12725V2.53294C37.4609 3.15549 36.9562 3.6601 36.3336 3.6601Z",
    fill: "url(#paint36_linear_4466_7881)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4466_7881",
    x1: 9.54524,
    y1: 34.8436,
    x2: 11.3183,
    y2: 39.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4466_7881",
    x1: 8.6268,
    y1: 37.2571,
    x2: 12.5042,
    y2: 40.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4466_7881",
    x1: 7.54742,
    y1: 30.776,
    x2: 11.2627,
    y2: 35.4585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4466_7881",
    x1: 8.46158,
    y1: 35.1478,
    x2: 11.9921,
    y2: 36.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4466_7881",
    x1: 12.4334,
    y1: 24.8505,
    x2: 12.8188,
    y2: 32.7894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4466_7881",
    x1: 11.841,
    y1: 28.959,
    x2: 14.1495,
    y2: 32.3698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4466_7881",
    x1: 41.4593,
    y1: 34.84,
    x2: 39.6862,
    y2: 39.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4466_7881",
    x1: 42.3778,
    y1: 37.2535,
    x2: 38.5004,
    y2: 40.4759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4466_7881",
    x1: 43.4572,
    y1: 30.7724,
    x2: 39.7419,
    y2: 35.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4466_7881",
    x1: 42.543,
    y1: 35.1443,
    x2: 39.0125,
    y2: 36.0265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4466_7881",
    x1: 38.5711,
    y1: 24.8469,
    x2: 38.1857,
    y2: 32.7859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4466_7881",
    x1: 39.1636,
    y1: 28.9554,
    x2: 36.8552,
    y2: 32.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4466_7881",
    x1: 15.8877,
    y1: 24.7968,
    x2: 32.3305,
    y2: 41.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4466_7881",
    x1: 33.5713,
    y1: 42.4806,
    x2: 17.1934,
    y2: 26.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4466_7881",
    x1: 17.7443,
    y1: 26.6536,
    x2: 30.5106,
    y2: 39.4199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4466_7881",
    x1: 25.5001,
    y1: 38.9706,
    x2: 25.5001,
    y2: 49.2039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4466_7881",
    x1: 34.8376,
    y1: 42.5119,
    x2: 21.9617,
    y2: 34.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4466_7881",
    x1: 22.2524,
    y1: 31.4456,
    x2: 28.1089,
    y2: 37.3019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4466_7881",
    x1: 29.0092,
    y1: 33.0423,
    x2: 20.9148,
    y2: 36.3886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4466_7881",
    x1: 26.8958,
    y1: 35.915,
    x2: 22.4642,
    y2: 34.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4466_7881",
    x1: 24.1044,
    y1: 35.915,
    x2: 28.536,
    y2: 34.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4466_7881",
    x1: 24.2029,
    y1: 36.1373,
    x2: 27.0517,
    y2: 31.5588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4466_7881",
    x1: 26.5789,
    y1: 35.5591,
    x2: 26.3415,
    y2: 31.0823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#678D98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#678D98",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4466_7881",
    x1: 33.1828,
    y1: 27.8227,
    x2: 27.1697,
    y2: 17.2998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4466_7881",
    x1: 26.1974,
    y1: 5.55637,
    x2: 30.0699,
    y2: 11.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4466_7881",
    x1: 22.3348,
    y1: -2.02167,
    x2: 34.3609,
    y2: 11.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4466_7881",
    x1: 25.5001,
    y1: 6.5195,
    x2: 25.5001,
    y2: 3.28088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1261,
    stopColor: "#017FF3",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3306,
    stopColor: "#0176DB",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    stopColor: "#0268B4",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8857,
    stopColor: "#02547E",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4466_7881",
    x1: 19.78,
    y1: 0.206101,
    x2: 31.8061,
    y2: 13.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4466_7881",
    x1: 29.2251,
    y1: 10.4905,
    x2: 30.8987,
    y2: 12.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1261,
    stopColor: "#017FF3",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3306,
    stopColor: "#0176DB",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    stopColor: "#0268B4",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8857,
    stopColor: "#02547E",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4466_7881",
    x1: 21.7751,
    y1: 10.4905,
    x2: 20.1016,
    y2: 12.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0182FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1261,
    stopColor: "#017FF3",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3306,
    stopColor: "#0176DB",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    stopColor: "#0268B4",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8857,
    stopColor: "#02547E",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4466_7881",
    x1: 33.9987,
    y1: 17.4131,
    x2: 13.8948,
    y2: -2.69084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4466_7881",
    x1: 25.5001,
    y1: 8.00671,
    x2: 25.5001,
    y2: 21.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4466_7881",
    x1: 25.5,
    y1: 15.9805,
    x2: 25.5,
    y2: 20.4946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4466_7881",
    x1: 30.1341,
    y1: 13.4247,
    x2: 27.389,
    y2: 16.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766E6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#716B6B",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5705,
    stopColor: "#656060",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#514F4F",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4466_7881",
    x1: 23.3923,
    y1: 16.5196,
    x2: 28.5913,
    y2: 21.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4466_7881",
    x1: 26.9952,
    y1: 20.1228,
    x2: 24.4216,
    y2: 17.5491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4466_7881",
    x1: 25.5001,
    y1: 1.11108,
    x2: 25.5001,
    y2: 3.15402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_7881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silver-medal.1b4c053b0b5f49a0ce9d7f8bfbe7aa1a.svg";
export { ForwardRef as ReactComponent };